import { render, staticRenderFns } from "./TaxAttorney.vue?vue&type=template&id=933317d8&scoped=true&"
import script from "./TaxAttorney.vue?vue&type=script&lang=js&"
export * from "./TaxAttorney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933317d8",
  null
  
)

export default component.exports